import React, { useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { Button, CardActionArea, CardActions } from '@mui/material';
import Badge from 'react-bootstrap/Badge';
import { v4 as uuid } from "uuid";

export default function GameSteamFree() {
    const [massives, setMassive] = useState([
        {
            id: uuid(),
            title: 'Brawlhalla',
            text: 'Вступайте в нерейтинговые бои, где каждый сам за себя, участвуйте в рейтинговых сражениях или создайте пользовательскую игру вместе с друзьями. Драки ждут вас! Сражайся с друзьями и стань номером один!',
            button: 'Перейти',
            img: 'https://www.digiseller.ru/preview/384896/p1_3437029_8ebf1ed9.jpg',
            href: 'https://store.steampowered.com/app/291550/Brawlhalla/',
            free: 'Бесплатная'
        },
        {
            id: uuid(),
            title: 'Dread Hunger',
            text: 'Это очень красивое психологическое приключение, в котором группа из восьми исследователей XIX века оказывается в Арктике и сталкивается с предательством двух злодеев из числа команды',
            button: 'Перейти',
            img: 'https://img.youtube.com/vi/TI-3h0JXjic/maxresdefault.jpg',
            href: 'https://store.steampowered.com/app/1418630/Dread_Hunger/',
            free: 'Платная'
        },
        {
            id: uuid(),
            title: 'Oddworld: Soulstorm',
            text: 'Присоединяйтесь к революции! Эйб возвращается в игре Oddworld: Soulstorm Enhanced Edition, где также появилась Побег Тоби: новый игровой режим, делающий игру Soulstorm ещё более взрывной и захватывающей',
            button: 'Перейти',
            img: 'https://cdn1.epicgames.com/offer/e099f2abf3324d248054bf14c476fbc0/EGS_OddworldSoulstormEnhancedEdition_OddworldInhabitantsInc_S1_2560x1440-fbeb3142b95776c4a70dbab7dbc8b3b2',
            href: 'https://store.steampowered.com/app/619390/Oddworld_Soulstorm_Enhanced_Edition/',
            free: 'Платная'
        },
        {
            id: uuid(),
            title: 'Tera онлайн',
            text: 'Игра последнего поколения, выполненная в жанре фентези. В TERA Online вы найдёте лучшую боевую систему, самую красивую и детализированную графику, качественные текстуры, отличный сервис',
            button: 'Перейти',
            img: 'https://brommos.ru/images/tera_online_big.jpg',
            href: 'https://store.steampowered.com/app/212740/TERA__Action_MMORPG/',
            free: 'Бесплатная'
        },
        {
            id: uuid(),
            title: 'Аллоды онлайн',
            text: 'Фэнтезийная многопользовательская ролевая онлайн-игра, продолжающая игровую серию «Аллоды», но уже в масштабе MMORPG-вселенной. Достаточно хороший плагиат WorldOfWarcraft',
            button: 'Перейти',
            img: 'https://greatgamer.ru/images/games_cover/cover_11605.jpg',
            href: 'https://store.steampowered.com/app/381640/_/',
            free: 'Бесплатная'
        },
        {
            id: uuid(),
            title: 'Escape the Backrooms',
            text: 'очередной проект в жанре хоррора с многопользовательским геймплеем, созданный по мотивам закулисья. События предлагают пройти ряд уровней, выполненных в виде комнат и помещений офиса, размещенных в виде лабиринта',
            button: 'Перейти',
            img: 'https://le-cdn.website-editor.net/6b660b82e5b34494b05bd04cfdaefb2c/dms3rep/multi/opt/hazmat2-1920w.png',
            href: 'https://store.steampowered.com/app/1943950/Escape_the_Backrooms/',
            free: 'Платная'
        },
        {
            id: uuid(),
            title: 'Paragon: The Overprime ',
            text: 'Выбирайте себе одного из сильных героев с уникальными способностями. Почувствуйте свободу и восторг от битв с лучшими героями Прайма.',
            button: 'Перейти',
            img: 'https://yandex-images.clstorage.net/4QiDr9203/283235Nit/R01kl7ZskWFA0OTFGnjHtPfMIzgW_0Xh_L55foDjK4ITUYL13RWNzgh_rIHrBen27FwfBLZpU40bSpsynyCk8UcMIaaHeYkMPYn0pEpYy6D_uVY0Uo4t8IjXcA_Uuwe-MhmX_IR8ie4RV_359qxRay2E-txnnIZNrnvGXpZphKkLQZw6srQYEVD4FSFKFC_gJyWPOBby7czkNgxHPOoLQ6PoVqggHPC-3SPYmBr4kcMZHAJkv-i2RYrfAr4u0Q2FB328Q66YVB3wcHnt5pwfjKcNJ1jSBm0sBEJUK0jaK4uTgBJ80BAQNilj7LSSZJFPJTRK7DuM1lEyF6amIq3pUftxXOPiHNiBeMxpzbKUN-B_9dsMQg4pBIii-Gv05svL8zheKEj0FMbVrxiYjrhlT-1k1iSLkL4h0k8Ocg5VuXGXvSiT-rC4OfxchdGWlOOsvwW3yLaOnUCoQiijxMLznxP8BmDYFCgSvV8EAJ70BefhEJJw_yQyZTobBlbG9YW177FUSyaIjD1YCB3t3jBHOCu9O7DatuEMWCY0M-xyO1ufwMKoDJgMsuE_KMgK8JmjZUgehPMIQnEiW0ZCDvGFAUfV-BvaKIhVQMT1udKY8xRfIXsQzk5tFLDGgG_wNqszA9RCLNzo-ELFd5AAdvxph01YjtwT5FqpOrcCPloVdbEfQcR35gSQ1fhcJcXeyL84e23HOI72WVykwvSrAC7vn_OInmysbHSWNXtUvOKYhcOFWEK8M-hOUTKz2gIOGf0N58ncA_pscHkQ2I1pShi7AIuhL8Cyxq2cMIowF3T2p-OPDDJcjGzcLtWTFJQiCEVjHdiuCLtglm0iT24m2s3VmQfJCGsu4PRRpAzNtUbQ7_zTSbs04mJR2Awq1Cv0pksvE5z6yDxYjJZZK6S0UuwN1-m4wvzHDPLlgoNa6hpFfTUTAeRnBuCAuayUlUlGcLsAs6EfPE4W9ciwqtgfxFI0',
            href: 'https://store.steampowered.com/app/1531430/Paragon_The_Overprime/',
            free: 'Бесплатная'
        },
        {
            id: uuid(),
            title: 'Stumble Guys',
            text: 'Бегите, прыгайте и пересекайте финишную линию — возможно, именно вы станете чемпионом! Игра очень похожа на FallGuys только со своими небольшими особенностями, попробуй и ты стать номером один!',
            button: 'Перейти',
            img: 'https://avatars.mds.yandex.net/i?id=6debd7dbab79e98df888828fa9ff8b15-4080375-images-thumbs&ref=rim&n=33&w=211&h=150',
            href: 'https://store.steampowered.com/app/1677740/Stumble_Guys/',
            free: 'Бесплатная'
        },
        {
            id: uuid(),
            title: 'Neighbours from Hell',
            text: 'Компьютерная игра-аркада. Главной целью игры является месть соседу. Герою нужно находить предметы и использовать их, чтобы навредить соседу. В одной игре присутствуют 14 эпизодов. Вспомни молодость!',
            button: 'Перейти',
            img: 'https://i.ytimg.com/vi/3PgIk2Rt73A/maxresdefault.jpg',
            href: 'https://store.steampowered.com/app/260750/Neighbours_from_Hell_Compilation/',
            free: 'Платная'
        },
        {
            id: uuid(),
            title: 'UltimateChickenHorse',
            text: 'Ultimate Chicken Horse – необычный соревновательный платформер, в котором вы не просто проходите уровни, но и участвуете в их создании. Ставте ловушки чтобы ваши соперники не пришли первые. Кооператив 4 человека.',
            button: 'Перейти',
            img: 'https://steamrip.com/wp-content/uploads/2021/05/Ultimate-Chicken-Horse-Free-Download.jpg',
            href: 'https://store.steampowered.com/app/386940/Ultimate_Chicken_Horse/',
            free: 'Платная'
        },
        {
            id: uuid(),
            title: 'GumBallRun ',
            text: 'Это игра в жанре гонки и аркада, разрабатываемая Glenn Verheij для платформы PC. Выделить особенности можно следующие: гонки, для нескольких игроков,3d-платформер, кастомизация персонажа, процедурная генерация',
            button: 'Перейти',
            img: 'https://cdn.cloudflare.steamstatic.com/steam/apps/2124930/header.jpg?t=1673305225',
            href: 'https://store.steampowered.com/app/2124930/Gum_Ball_Run/',
            free: 'Бесплатная'
        },
        {
            id: uuid(),
            title: 'FirstClassTrouble',
            text: 'First Class Trouble — командная игра, в которой игрокам предстоит пережить катастрофу, действуя как совместно, так и друг против друга. Отключите смертоносный искусственный интеллект круизного лайнера.',
            button: 'Перейти',
            img: 'https://cdn-ext.fanatical.com/production/product/1280x720/a2b33b90-ce49-40d7-9c28-cff27b990863.jpeg',
            href: 'https://store.steampowered.com/app/953880/First_Class_Trouble/',
            free: 'Платная'
        },
        {
            id: uuid(),
            title: 'Саспектс',
            text: 'Suspects - это игра на выживание, в которой вы становитесь либо гостем, либо убийцей. Задача гостя - определить всех убийц и проголосовать против них. Задача убийцы - устранить всех гостей, необходимые для победы.',
            button: 'Перейти',
            img: 'https://android-phones.ru/wp-content/uploads/2021/12/maxresdefault.jpg',
            href: 'https://www.bluestacks.com/ru/apps/action/suspects-mystery-mansion-on-pc.html',
            free: 'Платная'
        },
        {
            id: uuid(),
            title: 'Пико парк',
            text: 'Игра-головоломка с элементами экшена. Поддерживается как одиночный, так и многопользовательский режим, где участники взаимодействуют между собой для решения общих задач и трудностей.',
            button: 'Перейти',
            img: 'https://i.ytimg.com/vi/_JEeGDuTttA/maxresdefault.jpg',
            href: 'https://store.steampowered.com/app/1509960/PICO_PARK/',
            free: 'Платная'
        },
        {
            id: uuid(),
            title: 'Гусь гусь дак',
            text: 'Это ролевой экшен в жанре социальной дедукции ,  где шумная группа гусей пытается выявить в своих рядах шпионов и замаскированных кряков, и изгнать уток из своих пернатых рядов . Утята к бою!',
            button: 'Перейти',
            img: 'https://volsiz.ru/wp-content/uploads/2021/10/goose-goose-duck.jpg',
            href: 'https://store.steampowered.com/app/1568590/Goose_Goose_Duck/',
            free: 'Бесплатно'
        },
        {
            id: uuid(),
            title: 'Фазмафобия',
            text: 'Phasmophobia — это психологический онлайн-хоррор для четырёх игроков, в котором вы и члены вашей команды исследователи паранормальных явлений попадете в локации, и собираете доказательства.',
            button: 'Перейти',
            img: 'https://pic.rutubelist.ru/video/cd/33/cd3340e01d5d3f13bdc09aa04afb2ed3.jpg',
            href: 'https://store.steampowered.com/app/739630/Phasmophobia/',
            free: 'Платная'
        },
        {
            id: uuid(),
            title: 'Гост вотчерс',
            text: 'GhostWatchers — это психологический онлайн-хоррор для четырёх игроков, в котором вы и члены вашей команды исследователи паранормальных явлений попадете в локации, и собираете доказательства.',
            button: 'Перейти',
            img: 'https://i.ytimg.com/vi/j7DqsaLraqM/maxresdefault.jpg?7857057827',
            href: 'https://store.steampowered.com/app/1850740/Ghost_Watchers/',
            free: 'Платная'
        },
        {
            id: uuid(),
            title: 'Вич ит',
            text: 'Witch It — игра в прятки по сети. Ведьмы прячутся, отважные охотники их ищут, а вокруг царит веселье и волшебство. Прячьтесь и охотьтесь в полном красок и волшебства. В миреЧего только нет в мире Witch It',
            button: 'Перейти',
            img: 'https://gametrex.com/wp-content/uploads/2019/02/Witch-It-Free-Download.png',
            href: 'https://store.steampowered.com/app/559650/Witch_It/',
            free: 'Платная'
        },
        {
            id: uuid(),
            title: 'З мортуари асистент',
            text: 'The Mortuary Assistant — приключенческий хоррор с элементами исследования и демонами. Получив степень в области моргов, вам предстоит отгадать в ком находится демон, не совершите ошибку!',
            button: 'Перейти',
            img: 'https://pic.rutubelist.ru/video/fa/a9/faa96fe187ab6bfad05c60df179b2e3a.jpg',
            href: 'https://store.steampowered.com/app/1295920/The_Mortuary_Assistant/',
            free: 'Платная'
        },
        {
            id: uuid(),
            title: 'Арк',
            text: 'Будучи выброшенным голым на берег таинственного острова вам придется заниматься ремеслом, строительством. Используйте опыт и ловкость, чтобы приручать, разводить и ездить на первобытных существах, живущих в ARK',
            button: 'Перейти',
            img: 'https://i.playground.ru/p/yVPJULMkwv026NZOFcowEw.jpeg',
            href: 'https://store.steampowered.com/app/346110/ARK_Survival_Evolved/',
            free: 'Платная'
        },
        {
            id: uuid(),
            title: 'В райсинг',
            text: 'V Rising — это одновременно симулятор строительства и выживания в открытом мире. Игрок начинает как только что возродившийся вампир. Ему нужно собирать материалы чтобы построить свой собственный замок.',
            button: 'Перейти',
            img: 'https://i.playground.ru/e/_oVYnfc5DTnC61UydnAmng.png',
            href: 'https://store.steampowered.com/app/1604030/V_Rising/',
            free: 'Платная'
        },
        {
            id: uuid(),
            title: 'Нью ворлд',
            text: 'New World была анонсирована в 2016 году Amazon Game Studios вместе с двумя другими играми: Breakaway и Crucible. Из них только New World дожила до релиза. Это массовая онлайновая ролевая игра в сеттинге колонизации Америки',
            button: 'Перейти',
            img: 'https://i.playground.ru/e/vgwNa5vDAOgqp9usupgxoQ.jpeg',
            href: 'https://store.steampowered.com/app/1063730/New_World/',
            free: 'Платная'
        },
        {
            id: uuid(),
            title: 'Валхейм',
            text: 'Valheim — это экшен-песочница с элементами выживания, события которой происходят в одном из миров нордической мифологии, куда попадают павшие викинги Задача игрока — бороться со злом, угрожающему этому измерению.',
            button: 'Перейти',
            img: 'https://i.playground.ru/p/1DGOdmue2GVHZrVFpeJb6Q.jpeg',
            href: 'https://store.steampowered.com/app/892970/Valheim/',
            free: 'Платная'
        },
        {
            id: uuid(),
            title: 'Висаж',
            text: 'Visage — приключенческий хоррор, вдохновленный творением Хидэо Кодзимы (Hideo Kojima) – P.T. Основные действия игры происходят в 80-ых годах прошлого столетия, в котором погибло большое количество семей',
            button: 'Перейти',
            img: 'https://newxboxone.ru/wp-content/uploads/2021/10/wccfvisage1-1480x833-1.jpg',
            href: 'https://store.steampowered.com/app/594330/Visage/',
            free: 'Платная'
        },
    ]
    );

    return (
        <div className='GameSteamFree'>
            <h1 className='GameBrauser_h1'> <img className='Game_image' src="https://media.discordapp.net/attachments/1047046814672629820/1066371207198425119/image.png" alt="" /> Топ Steam игры</h1>
            <div className='GameBrauser_block'>
                {massives.map((massive, i) => (
                    <Card sx={{ maxWidth: 280 }} key={massive.id} className='GameBrauser_card'>
                        <CardActionArea >
                            <CardMedia
                                component="img"
                                height="140"
                                image={massive.img}
                                alt="green iguana"
                            />
                            <CardContent className='GameBrauser_text'>
                                <Typography gutterBottom variant="h5" component="div">
                                    {massive.title}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {massive.text}
                                </Typography>
                            </CardContent>
                        </CardActionArea>
                        <CardActions className='GameSteamFree_CardActions'>
                            <Button size="small" color="primary" href={massive.href} className='GameBrauser_button' target="_blank">
                                {massive.button}
                            </Button>
                            <Badge bg="primary">
                                {massive.free}
                            </Badge>
                        </CardActions>
                    </Card>
                ))
                }
            </div >
        </div>
    )
}
